module.exports = __webpack_public_path__ + "img/boy-body-back.18d59ded.png";